import { ObavijestOPrivatnostiPage } from "./ObavijestOPrivatnostiPage";

export default function ObavijestOPrivatnosti() {
  return <ObavijestOPrivatnostiPage />;
}
